/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DataDialogPrompt } from './DataDialogPrompt';
import {
    DataDialogPromptFromJSON,
    DataDialogPromptFromJSONTyped,
    DataDialogPromptToJSON,
} from './DataDialogPrompt';

/**
 * 
 * @export
 * @interface ListDataDialogPromptsResponseContent
 */
export interface ListDataDialogPromptsResponseContent {
    /**
     * 
     * @type {Array<DataDialogPrompt>}
     * @memberof ListDataDialogPromptsResponseContent
     */
    prompts?: Array<DataDialogPrompt>;
}


/**
 * Check if a given object implements the ListDataDialogPromptsResponseContent interface.
 */
export function instanceOfListDataDialogPromptsResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListDataDialogPromptsResponseContentFromJSON(json: any): ListDataDialogPromptsResponseContent {
    return ListDataDialogPromptsResponseContentFromJSONTyped(json, false);
}

export function ListDataDialogPromptsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDataDialogPromptsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prompts': !exists(json, 'prompts') ? undefined : ((json['prompts'] as Array<any>).map(DataDialogPromptFromJSON)),
    };
}

export function ListDataDialogPromptsResponseContentToJSON(value?: ListDataDialogPromptsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prompts': value.prompts === undefined ? undefined : ((value.prompts as Array<any>).map(DataDialogPromptToJSON)),
    };
}

